export default __webpack_public_path__ + "static/media/parsiq.060bf6be.svg";